/**
 * Textos do painel "Formalização preparada para revisão" (E152.F3, GUS-175, ADR-0103 §5.9): a
 * conferência da análise, a conclusão e a proposta, os pontos que pedem o perito com a revisão
 * fundamentada, as revisões registradas e, por expansão, requisitos, rotas, elementos de prova,
 * achados e diligências. É material da equipe: o cliente não revisa a análise.
 */
export const ptBRFormalizacaoAvaliacao = {
  titulo: 'Formalização preparada para revisão',
  carregando: 'Carregando a análise da formalização…',
  erro: 'Não foi possível carregar a análise da formalização. Tente novamente.',
  semPermissao: 'A análise da formalização é da equipe que atende o caso.',
  naoEncontrado: 'Caso não encontrado.',
  tentarDeNovo: 'Tentar de novo',
  versao: 'Versão {versao} · catálogo {catalogo} · {modo} · registrada em {data}',
  modo: {
    parte: 'modo PARTE',
    juizo: 'modo JUÍZO',
  },
  notaDaConferencia: 'A conferência verifica a análise; ela não muda a conclusão.',
  limite: 'Nenhuma conclusão afirma validade civil, nulidade, fraude ou regularidade financeira.',
  rotulos: {
    conclusao: 'Conclusão',
    proposta: 'Proposta ao perito',
    pendencia: 'Por que está pendente',
    leitura: 'Leitura que sustenta',
    razao: 'Razão da escolha',
  },
  semProposta: 'Sem proposta: a análise ainda não tem o que sustentar.',
  conferencia: {
    aprovado: 'Conferência aprovada · pronta para a sua revisão',
    corrigir: 'Conferência pede correção · confira os fundamentos antes do laudo',
    bloqueado: 'Conferência bloqueada · a análise não segue para o laudo',
  },
  conclusao: {
    regular: 'FORMALIZAÇÃO REGULAR',
    irregular: 'FORMALIZAÇÃO IRREGULAR',
    nao_demonstrada: 'REGULARIDADE DA FORMALIZAÇÃO NÃO DEMONSTRADA',
    pendente: 'PENDENTE',
  },
  motivoDaPendencia: {
    prontidao: 'Aguarda o exame das peças',
    pendencia_normativa: 'Pendência normativa decisiva',
    revisao_especializada: 'Aguarda a sua revisão',
    diligencia_decisiva: 'Diligência decisiva aberta',
  },
  pontos: 'Pontos que precisam da sua revisão',
  semPontos: 'Nenhum ponto aguarda a sua revisão nesta versão.',
  verFonte: 'Ver fonte e detalhes técnicos',
  reverPonto: 'Decisão em vigor: {decisao}. Uma nova decisão precisa de novo fundamento.',
  tipoDaRevisao: {
    face: 'Comparação facial proposta',
    contraprova: 'Contraprova apurada',
    suprimento: 'Suprimento da atribuição',
    diligencias: 'Diligências decisivas abertas',
    autorizacao: 'Autorização do desconto na CCB',
    credito: 'Crédito divergente da operação',
    integridade: 'Hash divergente num documento do instrumento',
  },
  decisao: {
    confirma_positiva: 'Confirmo: mesma pessoa',
    confirma_divergente: 'Confirmo: pessoas diferentes',
    mantem_inconclusiva: 'Mantenho inconclusiva',
    confirmada: 'Confirmo a contraprova',
    afastada: 'Afasto a contraprova',
    aceito: 'Aceito o suprimento',
    recusado: 'Recuso o suprimento',
    encerradas: 'Encerro sem o elemento (insuficiência confirmada)',
    mantidas: 'Mantenho abertas, à espera do elemento',
    localizada: 'Localizei a cláusula de autorização (informe documento, página e trecho)',
    nao_localizada: 'Não localizei a autorização na CCB',
    aceita: 'Conferi: aceito a divergência com fundamento',
    mantida: 'Mantenho a divergência',
  },
  formulario: {
    decisao: 'Sua decisão',
    fundamento: 'Sua revisão fundamentada',
    dica: 'Indique a fonte e o limite do que você confirmou ou corrigiu.',
    registrar: 'Registrar revisão',
    registrando: 'Registrando…',
    cancelar: 'Cancelar',
    faltaDecisao: 'Escolha uma decisão.',
    faltaFundamento: 'Escreva o fundamento da revisão.',
    registrada: 'Revisão registrada. A análise foi renovada.',
    localizacao: {
      titulo: 'Onde está a cláusula',
      documento: 'Documento',
      documentoDica: 'Como o instrumento se identifica (ex.: CCB nº 29706925).',
      pagina: 'Página',
      clausula: 'Cláusula (opcional)',
      clausulaDica: 'O número ou a letra, quando o instrumento numera as cláusulas.',
      trecho: 'Trecho da cláusula',
      trechoDica:
        'O trecho literal que autoriza o desconto, com o sentido e as condições da autorização.',
      faltaDocumento: 'Informe o documento.',
      faltaPagina: 'Informe a página (número a partir de 1).',
      faltaTrecho: 'Transcreva o trecho da cláusula.',
      proposta: {
        titulo: 'Proposta do sistema',
        dica: 'O sistema localizou a cláusula pelo conteúdo. Confira no documento antes de registrar; a proposta não afirma a autorização.',
        criterio: {
          titulo: 'pelo título da cláusula',
          expressao: 'pela expressão da autorização',
        },
        usar: 'Usar esta passagem',
        outras: 'Outras passagens que também autorizam o desconto',
      },
      situacao: {
        nao_localizada:
          'O sistema não localizou a cláusula no texto das CCBs. Indique o documento, a página e o trecho.',
        nao_lida:
          'Há CCB sem texto para a busca ({nomes}). Indique o documento, a página e o trecho.',
        sem_ccb: 'O caso não tem CCB lida. Indique o documento, a página e o trecho.',
        excede_o_teto:
          'A autorização está numa frase de mais de 2.000 caracteres ({onde}). O sistema não resume a frase, para não omitir condições. Indique o documento, a página e o trecho com as condições.',
        outra_finalidade:
          'As CCBs só autorizam o desconto para outra finalidade ({onde}), não em favor do INSS. Indique o documento, a página e o trecho da autorização ao INSS, se houver.',
      },
    },
    verificacao: {
      titulo: 'Verificação item a item',
      dica: 'Facultativa: confirme ou retifique só os itens que quiser; os demais seguem o que o sistema apurou. O texto do método no exame é o mesmo com ou sem esta verificação.',
      itemQualidade: {
        qualidade_documento_identidade: 'Qualidade da fotografia do documento',
        qualidade_ccb: 'Qualidade da Selfie/FotoDocContrato da formalização',
      },
      confirmado: 'Confirmo',
      retificado: 'Retifico',
      observacao: 'O que você observa no lugar',
      faltaObservacao: 'Escreva o que você observa no lugar.',
      faltam: 'Escreva o que você observa no lugar em {n} itens retificados.',
      documento: 'Documento',
      formalizacao: 'Formalização',
      adequacao: {
        adequada: 'adequada',
        limitada: 'limitada',
        inadequada: 'inadequada',
      },
      fator: {
        resolucao: 'resolução',
        nitidez: 'nitidez',
        iluminacao: 'iluminação',
        pose: 'pose',
        oclusao: 'oclusão',
      },
      semParecer:
        'O parecer facial em vigor não pôde ser lido; registre só a decisão sobre a conclusão.',
    },
  },
  recusa: {
    desatualizada:
      'A análise mudou desde que você abriu. Confira a versão nova antes de registrar; seu texto continua aqui.',
    fora_da_pendencia: 'Este ponto não está mais aberto nesta versão.',
    invalida: 'A decisão não vale para este ponto. Confira e tente de novo.',
    localizacao_incompleta:
      'A cláusula localizada precisa do documento, da página e do trecho (até 2.000 caracteres).',
    verificacao_incompleta:
      'A verificação precisa de uma decisão para cada item do parecer facial em vigor. Confira e tente de novo.',
    sem_permissao: 'Só a equipe que atende o caso registra a revisão.',
    nao_encontrado: 'Caso não encontrado.',
    indisponivel: 'Não foi possível registrar agora. Seu texto continua aqui; tente de novo.',
  },
  registradas: 'Revisões registradas',
  semRegistradas: 'Nenhuma revisão registrada.',
  emVigor: 'Em vigor',
  semVigor: 'Sem vigor nesta versão',
  sobreVersao: 'Sobre a versão {versao}, em {data}',
  porRevisor: ', por {revisor}',
  clausulaDa: 'Cláusula {clausula} da ',
  clausulaCitada: '{clausula}{documento}, pág. {pagina} — “{trecho}”',
  rever: 'Rever',
  facultativa: 'Facultativa',
  facultativaDescricao:
    'Apurado pelo sistema e já considerado no exame; revise só se julgar necessário.',
  facultativaSemApurado:
    'O sistema não localizou este ponto no material; o exame o trata como ausente. Indique-o, se houver.',
  revisar: 'Revisar',
  /** E184.F3 (GUS-145 item 4): a divergência apurada que se aceita com fundamento. */
  aceitarComFundamento: 'Aceitar com fundamento',
  valorLido: 'Valor lido (o aceite não o muda): {valor}',
  recolher: 'Recolher',
  detalhes: 'Ver análise completa e fontes',
  requisitos: 'Requisitos da leitura que sustenta',
  rotas: 'Rotas de atribuição',
  elementos: 'Elementos de prova',
  diligencias: 'Diligências',
  semDiligencias: 'Nenhuma diligência.',
  decisiva: 'Decisiva',
  reforco: 'Reforço, não suspende',
  falta: 'Falta: {itens}',
  situacaoDoRequisito: {
    demonstrado: 'Demonstrado',
    aguarda_revisao: 'Aguarda a revisão do perito',
    nao_demonstrado: 'Não demonstrado',
    contrariado: 'Contrariado por contraprova',
    pendente_normativo: 'Pendente de norma',
    nao_decisivo: 'Não decisivo nesta leitura',
  },
  situacaoDaRota: {
    completa: 'Completa',
    aguarda_revisao: 'Aguarda a revisão do perito',
    incompleta: 'Incompleta',
    inativa: 'Inativa no catálogo',
  },
  situacaoDoElemento: {
    demonstrado: 'Demonstrado',
    proposto: 'Proposto, aguarda o perito',
    inconclusivo: 'Inconclusivo',
    ausente: 'Ausente no material',
    nao_extraido: 'Ainda não extraído',
  },
  tipoDoElemento: {
    face_positiva: 'Comparação facial',
    documento_na_sessao: 'Documento capturado na sessão',
    credencial_do_titular: 'Credencial do titular',
    credito_em_conta: 'Crédito em conta do titular',
    evento_de_aceite: 'Aceite registrado',
    registro_com_carimbo: 'Registro com carimbo do tempo',
    declaracao_do_meio: 'Declaração do meio de assinatura',
    captura_coincidente: 'Captura com instante coincidente',
    autenticacao_efetiva: 'Autenticação efetiva',
    assinatura_digital_do_participante: 'Assinatura digital do participante',
    integridade_do_instrumento: 'Integridade do instrumento',
    decisao_biometrica: 'Decisão biométrica',
    prova_de_vida: 'Prova de vida',
    autenticacao_multifator: 'Autenticação em múltiplos fatores',
    termo_de_desbloqueio: 'Termo de desbloqueio',
    instrumento_de_consignado: 'Instrumento do consignado',
    autorizacao_do_desconto: 'Autorização do desconto localizada pelo perito',
    face_divergente: 'Comparação facial divergente',
    dados_essenciais_divergentes: 'Dados essenciais divergentes',
    conteudo_alterado: 'Conteúdo alterado',
  },
  achados: 'Achados e destinos',
  naoExecutada: 'Análise de riscos não executada: a análise aguarda o exame das peças.',
  semAchados: 'Análise concluída sem achados no alcance examinado.',
  criterioDoGrau: 'Critério do grau: {criterio}',
  naturezaDoAchado: {
    contraprova: 'Contraprova',
    limite_essencial: 'Limite essencial',
    limite_nao_decisivo: 'Limite do elemento',
    exigencia_legal: 'Exigência legal',
    diligencia_decisiva: 'Diligência decisiva',
    pendencia_normativa: 'Pendência normativa',
    tese_alternativa: 'Tese alternativa',
    item_nao_comprovado: 'Item não comprovado',
    reforco: 'Reforço',
  },
  destino: {
    laudo_essencial: 'Laudo',
    riscos_reservados: 'Orientações reservadas',
  },
  grau: {
    alto: 'Risco alto',
    medio: 'Risco médio',
    baixo: 'Risco baixo',
  },
  risco: {
    fundamento: 'Fundamento atingido',
    argumento: 'Argumento contrário',
    resposta: 'Resposta disponível',
    semResposta: 'Sem resposta disponível',
    providencia: 'Providência',
  },
  veracidade: 'Conferência da análise',
  criterio: {
    suporte: 'Toda afirmação cita prova demonstrada',
    teste_registrado: 'Teste dito executado tem o registro',
    limites_essenciais: 'Os limites essenciais estão no laudo',
    destino_do_essencial: 'O essencial vai ao laudo',
    reservado_so_em_parte: 'Orientações reservadas só em PARTE',
  },
  estadoDoCriterio: {
    passou: 'Passou',
    falhou: 'Falhou',
    inconclusivo: 'Inconclusivo',
    nao_se_aplica_justificado: 'Não se aplica',
  },
} as const;
